<template>
    <v-container
        fluid
        fill-height
        style="height: 100vh; background-color: #1A237E;"
        colors="indigo"
    >
        <v-layout justify-center align-center row wrap>
            <v-flex class="text-sm-center text-xs-center" lg4>
                <v-layout row wrap>
                    <v-flex lg12>
                        <h1
                            class="white--text font-weight-thin"
                            :class="{
                                'display-4': $vuetify.breakpoint.lgAndUp,
                                'display-3 pt-3': $vuetify.breakpoint.mdAndDown
                            }"
                        >
                            Teams
                        </h1>
                    </v-flex>
                    <v-flex v-if="$vuetify.breakpoint.lgAndUp">
                        <v-container fluid :pa-0="$vuetify.breakpoint.xsOnly">
                            <v-layout column wrap align-center justify-start>
                                <v-flex lg12>
                                    <v-btn
                                        class="indigo--text"
                                        color="indigo lighten-5"
                                        :class="{
                                            'pa-5 display-3 mt-5':
                                                $vuetify.breakpoint.xlOnly,
                                            'display-2 pa-3 mt-5':
                                                $vuetify.breakpoint.lgOnly
                                        }"
                                        ripple
                                        raised
                                        large
                                        to="/draft-order"
                                        >Continue</v-btn
                                    >
                                </v-flex>
                                <v-flex lg12>
                                    <v-btn
                                        class="indigo--text"
                                        color="indigo lighten-3"
                                        :class="{
                                            'pa-5 display-3':
                                                $vuetify.breakpoint.xlOnly,
                                            'display-2 pa-3':
                                                $vuetify.breakpoint.lgOnly
                                        }"
                                        ripple
                                        large
                                        to="/teams-edit"
                                        >Edit Teams</v-btn
                                    >
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex lg8>
                <v-container
                    v-bind="{ [`grid-list-md`]: true }"
                    fluid
                    style="overflow: auto;"
                    :class="{
                        maxHeight70: $vuetify.breakpoint.mdAndUp,
                        maxHeight60: $vuetify.breakpoint.smAndDown
                    }"
                    mt-3
                    grow
                >
                    <v-layout row wrap :px-5="$vuetify.breakpoint.lgAndUp">
                        <v-flex
                            v-for="(item, index) in teams"
                            :key="index"
                            xs12
                            sm6
                            lg6
                        >
                            <v-card tile height="auto">
                                <v-layout row wrap>
                                    <v-flex xs4 align-self-center>
                                        <v-avatar class="mx-3">
                                            <img
                                                :src="item.picture"
                                                v-if="item.picture !== ''"
                                            />
                                            <v-icon color="indigo" v-else
                                                >star</v-icon
                                            >
                                        </v-avatar>
                                    </v-flex>
                                    <v-flex
                                        xs8
                                        align-self-center
                                        class="text-capitalize"
                                    >
                                        <h2>
                                            {{ item.name }}
                                        </h2>
                                        <p class="ma-0">
                                            Coach: {{ item.coach }}
                                        </p>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.mdAndDown">
                <v-container fluid :pa-0="$vuetify.breakpoint.xsOnly">
                    <v-layout column wrap align-center justify-center>
                        <v-flex xs6>
                            <v-btn
                                class="indigo--text"
                                color="indigo lighten-5"
                                ripple
                                raised
                                large
                                to="/draft-order"
                                >Continue</v-btn
                            >
                        </v-flex>
                        <v-flex xs6>
                            <v-btn
                                class="indigo--text"
                                color="indigo lighten-3"
                                ripple
                                large
                                to="/teams-edit"
                                >Edit Teams</v-btn
                            >
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'TeamsList',
    computed: {
        teams() {
            return this.$store.state.teams;
        }
    }
};
</script>

<style scoped>
.maxHeight70 {
    max-height: 70vh;
}
.maxHeight60 {
    max-height: 60vh;
}
</style>
